const CAP44 = {
  id: 44,
  slug: "cap44-que-son-los-nodos",
  title: "Capítulo 44 — Qué son los Nodos",
  module: 4,
  sections: [
    {
      heading: "Resumen del capítulo",
      text: [
        "En este capítulo se desarrolla el tema: Qué son los Nodos."
      ]
    }
  ]
};

export default CAP44;
